import { render, staticRenderFns } from "./CardMail.vue?vue&type=template&id=540be6bb&"
import script from "./CardMail.vue?vue&type=script&lang=js&"
export * from "./CardMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports